export enum AddonsAllowancesScreen {
  ADDONS = "addons",
  ALLOWANCES = "allowances"
}